import { useReactFlow, Handle, Position, useStore, NodeResizer } from "@xyflow/react";
import { Button, Select } from "antd";
import { CloseOutlined, CopyOutlined } from "@ant-design/icons";
import NodeNameInput from "./NodeNameInput";

const COLOR = "#f59e0b";

const JumpNode = ({ data, selected, id }) => {
  const { deleteElements } = useReactFlow();
  const nodes = useStore((s) => s.nodes);

  const targetOptions = nodes
    .filter((n) => n.id !== id)
    .map((n) => ({
      value: n.id,
      label: `[${n.type}] ${n.data?.message || n.data?.triggerType || n.data?.question || n.id}`.slice(0, 50),
    }));

  return (
    <div style={{
      background: "#fff",
      border: `2px solid ${selected ? COLOR : "#e5e7eb"}`,
      borderRadius: 10,
      padding: 14,
      minWidth: 240,
      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      width: "100%",
      height: "100%",
      boxSizing: "border-box",
    }}>
      <NodeResizer minWidth={240} minHeight={80} isVisible={selected} color={COLOR} />
      <Handle type="target" position={Position.Left} style={{ background: COLOR }} />

      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
        <span style={{ fontSize: 16 }}>⬆️</span>
        <strong style={{ fontSize: 13 }}>Jump to Node</strong>
        <Button type="text" size="small" icon={<CopyOutlined />}
          onClick={() => data.onDuplicate?.()}
          style={{ marginLeft: "auto", color: "#9ca3af" }} />
        <Button type="text" size="small" icon={<CloseOutlined />}
          onClick={() => deleteElements({ nodes: [{ id }] })}
          style={{ color: "#9ca3af" }} />
      </div>

      <div className="nodrag" onPointerDown={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
        <NodeNameInput data={data} />
        <Select
          value={data.targetNodeId || undefined}
          onChange={(v) => data.onChange?.({ ...data, targetNodeId: v })}
          options={targetOptions}
          placeholder="Select target node"
          style={{ width: "100%" }}
          size="small"
          showSearch
          filterOption={(input, opt) => opt.label.toLowerCase().includes(input.toLowerCase())}
        />
        {data.targetNodeId && (
          <div style={{ marginTop: 6, fontSize: 10, color: "#f59e0b" }}>
            ⚠️ Loops allowed — max 10 iterations enforced
          </div>
        )}
      </div>
    </div>
  );
};

export default JumpNode;
